import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { Tag } from '../models/tag.model';

@Injectable({
    providedIn: 'root',
})
export class TagService {
    constructor(private httpClient: HttpClient) {}

    allTags: Tag[] = [];
    availableTagsForTicket: Tag[] = [];
    globalTags: Tag[] = [];
    notGlobalTags: Tag[] = [];
    tagsByCategory: Tag[] = [];

    add(tag: Tag): Observable<Tag> {
        return this.httpClient.post<Tag>(environment.apiInboxUrl + 'tags/', tag);
    }

    addGlobalTag(globalTag: Tag): void {
        this.globalTags.push(globalTag);
        this.globalTags = [...this.globalTags].sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
        this.allTags.push(globalTag);
        this.allTags = [...this.allTags].sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
    }

    getAll(isGlobal = true): Observable<Tag[]> {
        return this.httpClient.get<Tag[]>(environment.apiInboxUrl + 'tags?isGlobal=' + isGlobal);
    }

    getTagsByCategory(categoryId: number): Observable<Tag[]> {
        return this.httpClient.get<Tag[]>(environment.apiInboxUrl + 'tags?CategoryId=' + categoryId);
    }
}
